import { useCheckPermission } from 'hooks/useCheckPermission';
import { useIsFeatureEnabled } from 'hooks/useIsFeatureEnabled';
import MyELCDetail from 'pages/private/ELCs/ELCDetail/MyELCDetail';
import MyELCs from 'pages/private/ELCs/ELCList/MyELCs';
import MyELCPillarsOfStrength from 'pages/private/ELCs/ELCDetail/MyELCPillarsOfStrength';
import ActionPlan from 'pages/private/ELCs/ActionPlan/ActionPlan';
import { RoutesPaths, SubRouteType } from 'routes/Routes.types';

const useGetMyELCsSubRoutesData = () => {
  const isPillarsManagementEnabled = useIsFeatureEnabled('pillars_management');

  const MyELCsSubRoutes: SubRouteType[] = [
    {
      component: MyELCs,
      path: RoutesPaths.MYELCS,
      show: false,
      showByPermissions: useCheckPermission('MY_ELC_LIST_VIEW'),
    },
    {
      component: MyELCDetail,
      path: RoutesPaths.MYELCS_DETAIL,
      show: false,
      showByPermissions: useCheckPermission('MY_ELC_LIST_VIEW'),
    },
    {
      component: MyELCDetail,
      path: RoutesPaths.MYELCS_DETAIL_INPUTS_OUTPUTS,
      show: false,
      showByPermissions: useCheckPermission('MY_ELC_LIST_VIEW'),
    },
    {
      component: MyELCPillarsOfStrength,
      path: RoutesPaths.MYELCS_PILLARS_OF_STRENGTH,
      show: false,
      showByPermissions: useCheckPermission([
        'MY_ELC_LIST_VIEW',
        'PILLARS_VIEW',
      ]),
    },
    {
      component: ActionPlan,
      path: RoutesPaths.MYELCS_ACTION_PLAN,
      show: false,
      showByPermissions:
        useCheckPermission('MY_ELC_LIST_VIEW') && isPillarsManagementEnabled,
    },
  ];
  return { MyELCsSubRoutes };
};

export default useGetMyELCsSubRoutesData;
